import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert, Button } from "components/bootstrap";
import { Icon } from "components/common";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseTrialNotification = ({ expiresIn, onMuteClick }) => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", className: "has-bm", title: t("license.notifications.trial_title", { productName }) }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "license.notifications.trial_body",
      values: { expiresIn },
      components: { strong: /* @__PURE__ */ React.createElement("strong", null), licenseHelp: /* @__PURE__ */ React.createElement(LicenseHelp, null) }
    }
  ), /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", className: "pull-right", onClick: onMuteClick }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }), " ", t("license.notifications.remind_later"))));
};
export default LicenseTrialNotification;
